import React from "react";
import UserAccount from "./Pages/UserAccount/UserAccount"
import { Routes, Route, Navigate} from "react-router-dom";
import Login from "./Pages/Login/Login";
import Confirm from "./Pages/Confirm/Confirm";
import ConfirmCore from "./Pages/Confirm/ConfirmCore";
import MailRest from "./Pages/MailResetPassword/MailRest";
import Profile from "./Pages/Profile/Profile";
import ScientificStudies from "./Pages/Scientific_study/Study";
import Protocols from "./Pages/Protocoles/Protocoles";
import ElearningPageDetail from "./Pages/E-learning/ElearningPageDetail"
import ElearningDetail from "./Pages/E-learning/ElearningDetail"

import HomeAccount from "./Pages/BlogAccount/BlogAccount";
import TechnicalSupports from "./Pages/TechnicalSupports/TechnicalSupport";
import TechnicalSupportsPro from "./Pages/TechnicalSupports/TechnicalSupportPro";
import Elearning from "./Pages/E-learning/Elearning";
import Notifications from "./Pages/Notifications/Notifications";
import ClinicalsCsae from "./Pages/clincalsCase/ClinicalsCsae";
import MyFavoris from "./Pages/MyFavoris/MyFavoris"
import MyDevice from "./Pages/MyDevice/MyDevice";
import Users from "./Pages/Users/Users";
import Devices from "./Pages/Devices/Devices";
import Version from "./Pages/Version/Version";

import HomePage from "./Pages/HomePage/HomePage"
import MediaLibrary from "./Pages/MediaLibrary/MediaLibrary";
import Activation from "./Pages/Activation/Activation";
import ActivationRedirect from "./Pages/Activation/ActivationRedirect";
import AdminProprietaires from "./Pages/AdminProprietaires/AdminProprietaires";

const RoutesRouter = (props) => {
    return (
        <Routes>
            <Route path="/:lang/"
                element={<HomePage />}
            />
            <Route path="/:lang/create-account/"
                element={<UserAccount />}

            />
            <Route path="/:lang/connexion"
                element={<Login />}
            />
            <Route path="/:lang/confirm/"
                element={<Confirm />}
            />
            <Route path="/:lang/confirmCore/"
                element={<ConfirmCore />}
            />

            <Route path="/:lang/recupMail/"
                element={<MailRest />}
            />

            <Route path="/:lang/HomeAcademy/"
                element={<HomeAccount />} />

            <Route path="/:lang/ScientificStudies/"
                element={<ScientificStudies />}
            />

            <Route path="/:lang/Protocols/"
                element={<Protocols />}
            />
            <Route path="/:lang/ClinicalCase/"
                element={<ClinicalsCsae />}
            />

            <Route path="/:lang/ToolboxPhysio/"
                element={<TechnicalSupports />}
            />

            <Route path="/:lang/ToolboxPro/"
                element={<TechnicalSupportsPro />}
            />

            <Route path="/:lang/Users/"
                element={<Users />}
            />
            <Route path="/:lang/Devices/"
                element={<Devices />}
            />
            <Route path="/:lang/Version/"
                element={<Version />}
            />
            <Route path="/:lang/Profile/"

                element={<Profile />}

            />
            <Route path="/:lang/MyDevice/"

                element={<MyDevice />}

            />
            <Route path="/:lang/MyFavourites/"

                element={<MyFavoris />}

            />
            <Route path="/:lang/E-learning/"
                element={<Elearning />}

            />
            <Route path="/:lang/E-learning/:slug"
                element={<ElearningPageDetail />}

            />
            <Route path="/:lang/E-learning/:slug/:id"
                element={<ElearningDetail />}

            />

            <Route path="/:lang/Suitcase_Marketing/"
                element={<MediaLibrary />}

            />
            <Route path="/:lang/Notifications/"
                element={<Notifications />} />

            {/* QR des Pro connect convertis : /activer?sn=<CA...>&t=<jeton>.
                Chemin STATIQUE : il passe avant "/:lang/" (sinon « activer »
                serait pris pour une langue -> ecran blanc). */}
            <Route path="/activer" element={<ActivationRedirect />} />
            <Route path="/:lang/activer" element={<Activation />} />
            {/* Administration des proprietaires multiples (garde serveur : admin). */}
            <Route path="/:lang/AdminProprietaires" element={<AdminProprietaires />} />

            <Route path="/" element={<Navigate replace to="/fr/" />} />        

            {/* <Redirect exact from="/" to="/fr/" /> */}

        </Routes>
    );
};

export default RoutesRouter;
